"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const Radio_1 = require("./components/Radio");
const RadioGroup_styles_1 = require("./RadioGroup.styles");
/**
 * @deprecated please use <Ds.RadioGroup> instead
 */
const RadioGroup = (_a) => {
    var _b;
    var { dimension = "medium", theme = "traditional", checkPlacement = "top-left", formFieldWrapperProps = {}, radioInputs, children } = _a, props = __rest(_a, ["dimension", "theme", "checkPlacement", "formFieldWrapperProps", "radioInputs", "children"]);
    const validErrors = (_b = formFieldWrapperProps === null || formFieldWrapperProps === void 0 ? void 0 : formFieldWrapperProps.errors) === null || _b === void 0 ? void 0 : _b.filter(Boolean);
    const hasErrors = !!validErrors && validErrors.length > 0;
    const renderRadioInputs = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null, radioInputs.map((radioInput) => {
            return (react_1.default.createElement(Radio_1.Radio, Object.assign({ key: radioInput.id, dimension: dimension, checkPlacement: checkPlacement, theme: theme, hasErrors: hasErrors }, props, radioInput)));
        })));
    };
    return (react_1.default.createElement(__1.FormFieldWrapper, Object.assign({ as: "fieldset" }, formFieldWrapperProps),
        children && (react_1.default.createElement(RadioGroup_styles_1.RadioGroupChildrenWrapper, null, children)),
        props.columns ? (react_1.default.createElement("div", { className: "input-row" }, renderRadioInputs())) : (renderRadioInputs())));
};
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map